import axios from "axios"
import { UAParser } from "ua-parser-js";

const getDeviceInfo = () => {
  const parser = new UAParser();
  const result = parser.getResult();

  return {
    browser: result.browser.name,
    browserVersion: result.browser.version,
    os: result.os.name,
    osVersion: result.os.version,
    device: result.device.type || "desktop",
    deviceModel: result.device.model,
    deviceVendor: result.device.vendor,
    userAgent: result?.ua || "NA",
    screen: `${window.screen.width}x${window.screen.height}`
  };
};

// Set Default config options
const defaultOptions = {
    baseURL: 'https://badartech.net/api/',
    // baseURL: 'http://127.0.0.1:8000/api/',
    headers: {
      'Content-Type': 'application/json',
      'API-Key': process.env.REACT_APP_API_KEY,
      // 'device-info': JSON.stringify(getDeviceInfo()),
    },
  };

  // Create axios instance
  let Server = axios.create(defaultOptions);

  // Set AUTH token for any request
  Server.interceptors.request.use((config) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.access_token
    config.headers.Authorization = `Bearer ${token}`;
    const url = new URL(window.location.href);
    config.headers["client-path-name"] = url.pathname;
    return config;
  });

export const API_BASE_URL = defaultOptions.baseURL.replace(/\/api\/$/, '');
export default Server